export default{
    dialogKpiao:{
        Headers:{
            title:"添加发票(请仔细核对填写内容,以免影响报销)",
            title1:"发票管理",
            title2:"发票详情",
            title3:"发票信息",
            title4:"收票信息",
            title5:"开票进展"
        },
        form:{
            invoType:"发票类型",
            invoType1:"普通发票",
            invoType2:"增值税专用发票",
            invoCatgType:"发票类别",
            invoCatgType1:"个人",
            invoCatgType2:"企业",
            invoContentType:"发票内容",
            invoContentType1:"商品明细",
            invoContentType2:"商品类别",
            invoTitle:"发票抬头",
            taxIdentNum:"社会统一信用代码",
            invoRemarks:"备注信息",
            receName:"收票人姓名",
            tel:"收票人手机",
            areaList:"所在地区",
            addressDetail:"详细地址",
            registAddress:"注册地址",
            registTel:"注册电话",
            bankName:"开户银行",
            bankAccNum:"银行账户",

            shopName:"开票主体",
            invoCatg:"收票主体",
            invoAmount:"发票金额",
            applyDate:"申请时间",
            receName1:"收票人",
            remarks:"收票地址",
            tel1:"联系电话",
            xzdzfp:"下载电子发票",
            logisticsCompName:"进度跟踪",
            logisticsCompName1:"承运单位",
            logisticsNum:"配送单号",
            fname:"电子发票",
            ddxx:"订单信息",
            wlxx:"物流信息"
        },
        placeholder:{
            invoTitle:"请输入发票抬头",
            taxIdentNum:"请输入社会统一信用代码",
            invoRemarks:"请输入备注信息",
            receName:"请输入收票人姓名",
            tel:"请输入收票人手机号码",
            areaList:"请选择",
            addressDetail:"请输入详细地址信息",
            registAddress:"请输入注册地址",
            registTel:"请输入注册电话",
            bankName:"请输入开户银行",
            bankAccNum:"请输入银行账户",
        },
        rules:{
            receName:"请输入收票人姓名!",
            receName1:"请输入2-10字的收票人姓名！",
            areaList:"请选择所在地址",
            tel:"请输入手机号码",
            tel1:"请输入正确的手机号码",
            addressDetail:"请输入详细地址信息！",
            addressDetail1:"请输入4-50字的详细地址信息！",
            invoTitle:"请输入发票抬头",
            invoTitle1:"请输入发票请输入2-50字的发票抬头！抬头",
            taxIdentNum:"请输入15-20字的社会统一信用代码！",
            taxIdentNum1:"请输入正确的社会统一信用代码！",
            registTel:"请输入注册电话！",
            registAddress:"请输入注册地址！",
            registAddress1:"请输入4-100字的注册地址！",
            bankName:"请输入开户银行！",
            bankName1:"请输入20字的开户银行!",
            bankAccNum:"请输入银行卡账户!",
            bankAccNum1:"请输入正确的输入卡银行账户!",
        },
        Message:{
               success:"下载成功"
        },
        Alert:{

        },
        Button:{
            btnConfirm:"保存",
            btnClose:"取消",
            btnDetail:"查看详情",
        },
        Description:{
            defaultFlag:'设置为默认发票',
            defaultFlag1:"设置后系统将自动选中该发票抬头"
        },
           Table:{
            headerName1:['订单编号','商家名称','订单金额','退款金额','可开票金额','支付时间','操作'],
        }
    }
    
}